module.exports = __webpack_public_path__ + "static/media/hadi-partovi_200x200.974f9cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/hadi-partovi_200x200.png
// module id = 243
// module chunks = 0